if (typeof Promise.withResolvers !== 'function') {
  // @ts-expect-error Type '<T>() => { promise: Promise<unknown>; resolve: undefined; reject: undefined; }' is not assignable to type '<T>() => PromiseWithResolvers<T>'
  Promise.withResolvers = function() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export default defineNuxtPlugin({});
